import { Button, ButtonProps, CircularProgress, Tooltip } from "@mui/material";
import React from "react";

interface IAcxButtonPropsBase extends ButtonProps {
    tooltip?: string;
    disabledTooltip?: string;
    loading?: boolean;
    containerStyle?: Object;
    acxTheme?: "primary" | "secondary" | "tertiary";
}

export type IAcxButtonProps = Omit<IAcxButtonPropsBase, "color"> & {
    color?:
        | Exclude<
              ButtonProps["color"],
              "secondary" | "success" | "info" | "warning"
          >
        | "white"
        | "primary";
};

const AcxButton = React.forwardRef<HTMLSpanElement, IAcxButtonProps>(
    (
        {
            tooltip,
            loading,
            containerStyle,
            disabled,
            color,
            disabledTooltip,
            ...props
        },
        ref,
    ) => (
        <Tooltip
            title={tooltip || (disabled ? disabledTooltip || "Disabled" : "")}
            arrow
        >
            <span
                ref={ref}
                style={{
                    position: "relative",
                    display: "flex",
                    ...containerStyle,
                    ...(props.fullWidth ? { width: "100%" } : {}),
                }}
            >
                <Button
                    disableElevation
                    {...props}
                    color={color === "white" ? "secondary" : color}
                    disabled={disabled || loading}
                    sx={props.sx}
                >
                    {props.children}
                    {loading && (
                        <CircularProgress
                            color={"primary"}
                            size={20}
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                marginTop: -10,
                                marginLeft: -10,
                            }}
                        />
                    )}
                </Button>
            </span>
        </Tooltip>
    ),
);
export default AcxButton;

AcxButton.defaultProps = {
    color: "primary",
    children: "Button",
    variant: "contained",
};
